import * as React from 'react';
export const unbounceSvg = React.forwardRef(function unbounceSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#303030',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M16 4C9.368 4 4 9.368 4 16s5.368 12 12 12 12-5.368 12-12S22.632 4 16 4Zm-.429 16.714-.88 2.594a.702.702 0 0 1-.112.226c-.113.18-.248.316-.429.406a1.047 1.047 0 0 1-.88.067c-.496-.18-.811-.676-.744-1.172A7.662 7.662 0 0 1 8.353 16a7.687 7.687 0 0 1 9.136-7.556c.27-.429.812-.632 1.308-.474.27.09.474.27.609.496.113.203.18.429.158.677a.81.81 0 0 1-.045.248l-.88 2.594-3.068 8.73Zm.97 2.955 1.06-3.203A4.726 4.726 0 0 0 20.738 16c0-.97-.293-1.895-.812-2.64l1.06-3.202A7.655 7.655 0 0 1 23.692 16a7.723 7.723 0 0 1-7.15 7.67Z',
      fill: '#fff',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M11.263 16c0 1.67.88 3.135 2.188 3.992l2.978-8.706c-.136-.023-.294-.023-.429-.023A4.736 4.736 0 0 0 11.263 16Z',
      fill: '#fff',
    }),
  );
});
unbounceSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var unbounce = {
  category: 'brand',
  colorable: false,
  name: 'unbounce',
  svg: unbounceSvg,
};
